export function Stat({ value, label }: { value: string; label: string }) {
  return (
    <div className="stat">
      <div className="stat__num">{value}</div>
      <div className="stat__label">{label}</div>
    </div>
  );
}
